import { render, staticRenderFns } from "./evaluateList.vue?vue&type=template&id=2b2da347&scoped=true&"
import script from "./evaluateList.vue?vue&type=script&lang=js&"
export * from "./evaluateList.vue?vue&type=script&lang=js&"
import style0 from "./evaluateList.vue?vue&type=style&index=0&id=2b2da347&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2da347",
  null
  
)

export default component.exports